import { ComingSoon } from '@/components/shared/ComingSoon'
export function SalesPage() { return <ComingSoon title="Sales" description="Daily reconciliation, revenue by channel, and demand trends." /> }
